(function(){'use strict';function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}function fetchProductData(t){var r="/products/".concat(t,"?view=card");return fetch(r).then((function(t){return t.text()})).then((function(t){var r=t,e=(new DOMParser).parseFromString(r,"text/html");return JSON.parse(e.documentElement.querySelector("#delivery__time__template-json").textContent)})).catch((function(r){throw console.error("[fetchProductData] Failed to load content for handle: ".concat(t),r),r}))}function updateCartDrawerItems(){return fetch("".concat(routes.cart_url,"?section_id=cart-drawer")).then((function(t){return t.text()})).then((function(t){for(var r=(new DOMParser).parseFromString(t,"text/html"),e=0,n=["cart-drawer-items",".cart-drawer__footer"];e<n.length;e++){var o=n[e],c=document.querySelector(o),a=r.querySelector(o);c&&a&&c.replaceWith(a);}})).catch((function(t){throw console.error("[updateCartDrawerItems] Error updating cart drawer:",t),t}))}function getStockDate(e,t){for(var r=0,n=0;n<t.length;n+=1){r+=t[n].stock;var a=t[n];if(e<r)return a.stock_date}return null}function getLocaleFromURL(){var e=window.location.href.match(/\/\/(www\.)?reisenthel\.com\/([a-z]{2})\//);return e?e[2]:"de"}function getCartDateFormat(e){if(!e)return null;var t,r=new Date(e);switch(getLocaleFromURL()){case"fr":t=r.toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"});break;case"es":t=r.toLocaleDateString("es-ES",{day:"numeric",month:"long",year:"numeric"});break;case"it":t=r.toLocaleDateString("it-IT",{day:"numeric",month:"long",year:"numeric"});break;case"nl":t=r.toLocaleDateString("nl-NL",{day:"numeric",month:"long",year:"numeric"});break;case"de":t=r.toLocaleDateString("de-DE",{day:"numeric",month:"long",year:"numeric"});break;default:t=r.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});}return t}function getLineItemPropertyFormat(e){if(!e)return null;var t;if("string"==typeof e){var r=e.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);if(r){var n=_slicedToArray(r,4),a=n[1],o=n[2],i=n[3];t=new Date(i,o-1,a);}else t=new Date(e);}else t=new Date(e);return t.toLocaleDateString("en-GB",{day:"2-digit",month:"2-digit",year:"numeric"}).replace(/\//g,".")}function getLatestBundleDeliveryDate(e,t){if(window.bundleDates[t]=e,1===window.bundleDates.length)return e;try{for(var r=e,n=0;n<window.bundleDates.length;n++){if(window.bundleDates[n])new Date(window.bundleDates[n])>new Date(e)&&(r=window.bundleDates[n]);}return r}catch(t){return e}}function updateDeliveryDate(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;if(r)try{e=JSON.parse(r);}catch(e){return null}else {var a=document.querySelector("#pdp-delivery__time-json");a&&(e=JSON.parse(a.textContent));}var o=document.querySelectorAll(".delivery__date--properties"),i=document.querySelectorAll(".delivery__date--properties-checkout");if(!e)return null;var u=e.reduce((function(e,t,r){return "number"==typeof t.stock?e+t.stock:e}),0),l=document.getElementById("delivery_date"),c=t?parseInt(t,10):parseInt(null==l?void 0:l.getAttribute("data-inventory"),10),s=u-c,d=getStockDate(s,e),m=d;if(null!==n){m=getLatestBundleDeliveryDate(m,n);}var p=!!document.querySelector("cart-drawer.active");if(!l||p)return null==t?null:m;if(m){var f=new Date(m),v=getCartDateFormat(f),y=getLineItemPropertyFormat(f),g=l.getAttribute("data-text"),D="".concat(g," ").concat(v);l.querySelector("span").innerText=D,l.classList.remove("hidden"),o&&(o.forEach((function(e){e.value=y,e.name="properties[_delivery_date]";var t=e.dataset.imageUrl,r=e.closest("form").querySelector(".image__url--properties");r.name="properties[_image_url]",r.value=t;})),i.forEach((function(e){e.value=v,e.name="properties[".concat(g,"]");})));}else l.querySelector("span").innerText=l.getAttribute("data-default-text"),o&&o.forEach((function(e){return e.name="delivery-date"}));if("false"==l.getAttribute("data-available")){var _=l.getAttribute("data-unavailable-text");l.querySelector("span").innerText=_,l.classList.add("soldout-text");}else l.classList.remove("soldout-text");if(null!==n){var b=Array.from(document.querySelectorAll(".bundle-item")),h=b.every((function(e){var t;return null==e||null===(t=e.classList)||void 0===t?void 0:t.contains("checked")}));h&&l&&l.classList.remove("hidden");}else l&&l.classList.remove("hidden");}window.bundleDates||(window.bundleDates=[]);var getCartItemsDataToProcess=function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t,r,n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=document.querySelectorAll(".cart-item"),r=null,e.prev=2,e.next=5,fetch("/cart.js");case 5:return n=e.sent,e.next=8,n.json();case 8:r=e.sent,e.next=13;break;case 11:e.prev=11,e.t0=e.catch(2);case 13:return e.abrupt("return",Array.from(t).map((function(e){var t=e.querySelector(".item-delivery-time .date-text"),n=e.dataset,a=n.inventory,o=n.stock,i=n.isBundle,u=n.lineItemKey,l=n.quantity,c=n.translation,s=n.imageUrl,d=null;if(t){var m=t.textContent.trim();d=new Date(m);}var p=null;if(r&&r.items){var f=r.items.find((function(e){return e.key===u}));f&&f.properties&&(p=f.properties._dd_id||null);}if(i){var v=Array.from(e.querySelectorAll(".bundle-product-item")).map((function(e){var t=e.dataset;return {inventory:t.inventory,stock:t.stock}}));return {lineItemKey:u,date:d,inventory:a,stock:o,bundleItems:v,translation:c,imageUrl:s,ddId:p}}return {lineItemKey:u,date:d,inventory:a,stock:o,quantity:l,translation:c,imageUrl:s,ddId:p}})));case 14:case"end":return e.stop()}}),e,null,[[2,11]])})));return function(){return e.apply(this,arguments)}}(),updateCartItemDeliveryDate=function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r,n,a,o){var i,u,l,c,s;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return u=getLineItemPropertyFormat(t),l=getCartDateFormat(t),_defineProperty(i={_delivery_date:u||""},a,l||""),_defineProperty(i,"_image_url",o||""),c=i,s=JSON.stringify({id:r,quantity:n,properties:c}),e.prev=4,e.next=7,fetch("".concat(window.routes.cart_change_url),_objectSpread2(_objectSpread2({},fetchConfig()),{body:s}));case 7:e.sent.ok,e.next=13;break;case 11:e.prev=11,e.t0=e.catch(4);case 13:case"end":return e.stop()}}),e,null,[[4,11]])})));return function(t,r,n,a,o){return e.apply(this,arguments)}}(),calculateCartDeliveryDates=function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,a,o,i,u,l,c,s,d,m,p,f,v,y,g;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:r=_createForOfIteratorHelper(t.entries()),e.prev=1,r.s();case 3:if((n=r.n()).done){e.next=23;break}if(a=_slicedToArray(n.value,2),a[0],o=a[1],i=o.date,u=o.inventory,l=o.stock,c=o.lineItemKey,s=o.quantity,d=o.translation,m=o.bundleItems,p=o.imageUrl,f=o.ddId,!m){e.next=8;break}return e.abrupt("continue",21);case 8:if(!f||!f.includes("delivery_group_")){e.next=10;break}return e.abrupt("continue",21);case 10:if(!o.properties||"true"!==o.properties._gift_product){e.next=12;break}return e.abrupt("continue",21);case 12:if(v=updateDeliveryDate(u,l,d),y=i?new Date(i):null,g=v?new Date(v):null,!y&&!g||y&&g&&y.getFullYear()===g.getFullYear()&&y.getMonth()===g.getMonth()&&y.getDate()===g.getDate()){e.next=21;break}return e.next=19,updateCartItemDeliveryDate(v,c,s,d,p);case 19:e.next=21;break;case 21:e.next=3;break;case 23:e.next=28;break;case 25:e.prev=25,e.t0=e.catch(1),r.e(e.t0);case 28:return e.prev=28,r.f(),e.finish(28);case 31:case"end":return e.stop()}}),e,null,[[1,25,28,31]])})));return function(t){return e.apply(this,arguments)}}();window.addEventListener("DOMContentLoaded",(function(){updateDeliveryDate();})),document.addEventListener("delivery-date:update",function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetchProductData(t.detail.handle);case 2:updateDeliveryDate(e.sent);case 4:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()),document.addEventListener("bundle-variant:update",function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:r=t.detail.index,n=document.querySelectorAll(".bundle-item")[r],a=n.dataset.bundleItemStock,updateDeliveryDate(n.dataset.bundleItemInventory,a,r);case 5:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()),document.addEventListener("cart-drawer:open",(function(){setTimeout(_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t,r;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,getCartItemsDataToProcess();case 2:return t=e.sent,(r=document.querySelector(".cart__checkout-button"))&&(r.disabled=!0),e.prev=5,e.next=8,calculateCartDeliveryDates(t);case 8:return e.next=10,updateCartDrawerItems();case 10:e.next=14;break;case 12:e.prev=12,e.t0=e.catch(5);case 14:return e.prev=14,r&&(r.disabled=!1),e.finish(14);case 17:case"end":return e.stop()}}),e,null,[[5,12,14,17]])}))),0);}));
})();